import script from "./Alarms.vue?vue&type=script&lang=ts&setup=true"
export * from "./Alarms.vue?vue&type=script&lang=ts&setup=true"

import "./Alarms.vue?vue&type=style&index=0&id=585c1928&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-585c1928"]])

export default __exports__